import moment from 'moment';

export class SumupGroup {
  exec_date: string = null
  name: string = null
  assessment_score_type: number

  constructor(x: any){
    this.exec_date = x.exec_date;
    this.name = x.name;
  }
}

export class Curriculum {
  id: number
  name: string

  constructor(x: any){
    this.id = x.id;
    this.name = x.name;
  }
}

export class SumupUnit {
  id: number
  name: string
  curriculum_items: CurriculumItem[] = new Array<CurriculumItem>()
  score_bunpu_range: string
  sort_no: string
  unit_type: number
  course_code: string
  result_published: boolean = true
  destroy_enable: boolean = true
}

export class CurriculumItem {
  curriculum_id: number
  curriculum_name: string
  weight: string
  is_selected: boolean
}
